import { Dictionary, VueRouter } from "vue-router/types/router";

import { LogService } from "@/services";
import { VignetteRoutes } from "@/types";

/**
 * Custom router service that wraps and handles navigation errors
 */
export class RouterService {
  private static _initialized = false;

  static _initialize(): void {
    if (this._initialized) {
      LogService.error("RouterService is already initialized.");
      return;
    }
    LogService.debug("Initializing RouterService.");

    this._initialized = true;
    LogService.info("RouterService is initialized.");
  }

  public static navigateByName(
    router: VueRouter,
    name: VignetteRoutes,
    query?: Dictionary<string | (string | null)[] | null | undefined>,
    params?: Dictionary<string>,
    hash?: string,
    replaceInsteadOfPush = false
  ): void {
    if (router.currentRoute.name !== name || query != undefined) {
      if (replaceInsteadOfPush) {
        router.replace({ name, query, params, hash }).catch((err) => {
          LogService.info(`RouterService.navigateByName(replace) : '${err}'`);
        });
      } else {
        router.push({ name, query, params, hash }).catch((err) => {
          LogService.info(`RouterService.navigateByName : '${err}'`);
        });
      }
    } else {
      LogService.info(
        `RouterService.navigateByName - avoided duplicate navigation to '${name}'`
      );
    }
  }

  public static navigateByPath(router: VueRouter, path: string): void {
    if (router.currentRoute.path !== path) {
      router.push({ path: path }).catch((err) => {
        LogService.info(`RouterService.navigateByPath : '${err}'`);
      });
    } else {
      LogService.info(
        `RouterService.navigateByPath - avoided duplicate navigation to '${path}'`
      );
    }
  }

  /**
   * Navigate to the homepage for logged in users, or, via the route guards, to the almanac login screen for anon users.
   * @param router
   */
  public static navigateToHome(router: VueRouter): void {
    RouterService.navigateByName(router, VignetteRoutes.Home);
  }

  public static navigateToSubscriptionOptions(router: VueRouter): void {
    RouterService.navigateByName(
      router,
      VignetteRoutes.MyAccount,
      undefined,
      undefined,
      "#subscribe"
    );
  }
}
